import { executeRequest, JFSRequest } from '@jfs/network'
import { isSuccessResponse } from '../utils'
import { APIEndPoints } from './APIEndPoints'
import { getHeaders, getUrl, sitConfig } from './config'

const cardsListParser = (cards: any[]) => {
  let cardsList: any[] = []
  cards.map((card) => {
    cardsList.push({
      type: card.cardType,
      scheme: card.cardScheme,
      description: '',
      isDomesticAllowed: card.domesticAllowed,
      isInternationalAllowed: card.internationalAllowed,
      isPremium: card.premium,
      // isSelected: false,
    })
  })
  return cardsList
}

const responseParser = (response: any) => {
  let data = isSuccessResponse(response)
  return cardsListParser(data) ?? []
}

const getEMSCardsList = (entityId: string, tokens: any) => {
  const request: JFSRequest<{}> = {
    apiPath: getUrl(APIEndPoints.getEmsCardList),
    method: 'POST',
    cache: false,
    config: sitConfig(tokens),
    headers: getHeaders(),
    body: {
      entityId: entityId,
    },
  }

  return executeRequest(request)
    .then((resp) => responseParser(resp))
    .catch((error) => {
      throw error
    })
}

export { getEMSCardsList }
